function putElementToList($list, dateToCompare, EventToBeAdded, ListElementClass){
    $list.each(function(index){
        var eventDate = $(this).find('.event-date');
        var date1 = eventDate.text();
        var dateMoment = moment(date1, "DD MMMM YYYY");

        if (dateMoment.isValid()) {
            // Earlier date
            if (dateToCompare.isBefore(dateMoment)) {
                EventToBeAdded.insertBefore($(this))
                    .hide()
                    .show(200, ()=>{EventToBeAdded.fadeIn(500)});
                // If found, we can break iterations
                return false;
            }

            // The same dates
            if (dateToCompare.isSame(dateMoment)) {
                var clickedTime = EventToBeAdded.find('.event-time');
                var timeToCompare = $(this).find('.event-time');
                var clickedTimeMoment = moment(clickedTime.text(), "HH:mm");
                var timeToCompareMoment = moment(timeToCompare.text(), "HH:mm");

                // In case of earlier and same events, we can put this in front of the compared event
                if (clickedTimeMoment.isBefore(timeToCompareMoment) || clickedTimeMoment.isSame(timeToCompareMoment)) {
                    EventToBeAdded.insertBefore($(this))
                        .hide()
                        .show(200, ()=>{EventToBeAdded.fadeIn(500)});
                    return false;
                }
                // In case of later hours:
                else {
                    // If we compare with not the last one on the list, we can add after
                    if (index !== $list.length - 1) {
                        EventToBeAdded.insertAfter($(this))
                            .hide()
                            .show(200, ()=>{EventToBeAdded.fadeIn(500)});
                        return false;
                    }
                    // If we compare with the last one on the list, we can add only when length is smaller than 10
                    else {
                        if($list.length < 10) {
                            EventToBeAdded.insertAfter($(this))
                                .hide()
                                .show(200, ()=>{EventToBeAdded.fadeIn(500)});
                            return false;
                        }
                    }
                }
            }

            // If new event is the latest, but list is not already full
            if (index === $list.length - 1 && $list.length < 10){
                EventToBeAdded.insertAfter($(this))
                    .hide()
                    .show(200, ()=>{EventToBeAdded.fadeIn(500)});
            }
        }
        else {
            console.log("Date parsing error: ", date1);
        }

    })

    // // Finally, if the list contains more than 10 records, we have to remove the last one    
    var $newList = $(ListElementClass);
    setTimeout(()=>{
    if ($newList.length > 10) {
        $newList.last().fadeOut(500, ()=> { $newList.last().hide(200, () => { $newList.last().remove(); });});
    }
    }, 200);

}


function setActiveOngoingEventTab($ongoingEventsCard, isPresent){
    if (isPresent){
        $ongoingEventsCard.find('.tab-pane-ongoing-events').addClass("show active");
        $ongoingEventsCard.find('.tab-pane-ongoing-absent-events').removeClass("show active");
        $ongoingEventsCard.find('.ongoing-present').addClass("active");
        $ongoingEventsCard.find('.ongoing-absent').removeClass("active");

        
    } else {
        $ongoingEventsCard.find('.tab-pane-ongoing-events').removeClass("show active");
        $ongoingEventsCard.find('.tab-pane-ongoing-absent-events').addClass("show active");
        $ongoingEventsCard.find('.ongoing-present').removeClass("active");
        $ongoingEventsCard.find('.ongoing-absent').addClass("active");
    }
}


function sendAJAX(url, selectValue, callback) {
        
    const xhr = new XMLHttpRequest();
    var csrftoken = $.cookie('csrftoken'); // Get CSRFToken from cookie

    xhr.open("POST", url, true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.setRequestHeader('X-CSRFToken', csrftoken);

    xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            
            // Correctly returned from POST:
            if (xhr.status === 200) {
                callback(JSON.parse(xhr.responseText));
                
                
                // And we have to inform user about success
                $.toast({
                    text: "Deklaracja została ustawiona.",
                    icon: 'success',
                    showHideTransition: 'slide',
                    hideAfter: 3000,
                    stack: 5,
                    position: 'top-right',
                    loaderBg: '#f96868'
                });

            }
            
            // Error in POST:
            else {
            
                $.toast({
                    text: "Wystąpił błąd.",
                    icon: 'error',
                    showHideTransition: 'slide',
                    hideAfter: 3000,
                    stack: 5,
                    position: 'top-right',
                    loaderBg: '#f96868'
                });
            }
        }            
    }

    // Sending POST
    xhr.send(JSON.stringify(selectValue));
}


function addToCounter(className){
    var $counter = $('.' +className);

                var currentValue = parseInt($counter.text(), 10);
                if (!isNaN(currentValue)) {
                    var newValue = currentValue + 1;
                    $counter.text(newValue);
                } else {
                    console.error("value cannot be parsed into integer");
                }
}


$(document).on('change', '.select-main-page', function() {
        var selectValue = $(this).val();        
        var elementToRemove = $(this).closest('.ajax_section_element_event');
        var EventSectionClass = $(this).data('declaration-type');
        var AddToNotSure = false;

        if (selectValue === "7.00") {
            if (EventSectionClass === "not_known_events") {
                // if someone wants to set the same declaration, we shoud break the function
                return;
            }
            // if event was not declared before, probably we should move it to the list of not declared
            var NewNotSure = elementToRemove.clone();
            NewNotSure.addClass('not_known_event_element');

            var $NewNotSureTemporary = $(NewNotSure);
            var $innerElement = $NewNotSureTemporary.find('.select-main-page');
            $innerElement.attr('data-declaration-type', 'not_known_events');
            AddToNotSure = true;
        }
        
        // if user declares his presence, this event shoudl be copied and pasted in ongoing events.
        if (selectValue == 1 || selectValue == 0.5 || selectValue == 0.75) {
            var newOngoingEvent = elementToRemove.clone();
            newOngoingEvent.find('.select-element').remove();
            newOngoingEvent.attr('class', 'd-flex border-bottom border-top py-3 event-list-item ongoing-event-item'); 

            }

        
        if (selectValue == 0) {
            var newOngoingEvent = elementToRemove.clone();
            newOngoingEvent.find('.select-element').remove();
            newOngoingEvent.attr('class', 'd-flex border-bottom border-top py-3 event-list-item ongoing-absent-event-item'); 

            }

        

        var EventsSection = $('.' + EventSectionClass);
        var ensembleSlug = $(this).data('ensemble-slug');
        var eventSlug = $(this).data('event-slug');
        var url = `/api/event/${ensembleSlug}/${eventSlug}/set_declaration`;

        var dataToSend = {
            declaration: selectValue,
            not_declared_or_uknkown: EventSectionClass
        };

        sendAJAX(url, dataToSend, (responseData)=>{
            
            // If any new event returned from views, we have to set this data in the right format 
            if (Object.keys(responseData).length !== 0) {
                var NewElement = elementToRemove.clone();

                var eventTimeInfoElement = NewElement.find('.event-time-info');
                var iconElement = eventTimeInfoElement.find('i');
                eventTimeInfoElement.html('');
                eventTimeInfoElement.append(iconElement);
                eventTimeInfoElement.append(document.createTextNode(responseData.weekday + ', '));
                eventTimeInfoElement.append('<span class="event-date"></span>');
                eventTimeInfoElement.append('<span class="event-time"></span>');
                eventTimeInfoElement.find('.event-date').text(responseData.date + ' ');
                eventTimeInfoElement.find('.event-time').text(responseData.start);

                NewElement.find('select').attr('data-event-slug', responseData.slug).addClass('select-placeholder');
                var newLink = NewElement.find('a');
                newLink.text(responseData.name);
                var newURL = '/event/' + responseData.ensembleSlug + '/' + responseData.slug
                newLink.attr('href', newURL)
                NewElement.find('.event-place').text(responseData.place);
                
                // Handle private event badge
                var existingBadge = NewElement.find('.tickets-float');
                if (responseData.public === false) {
                    // If event is private and badge doesn't exist, create it
                    if (existingBadge.length === 0) {
                        var privateBadge = '<div class="tickets-float pt-2 mb-2"><span class="badge bg-info text-dark">wydarzenie niepubliczne</span></div>';
                        NewElement.find('.event-place').parent().append(privateBadge);
                    }
                } else {
                    // If event is public and badge exists, remove it
                    existingBadge.remove();
                }
                
                NewElement.find('.select-main-page').on('change', function () {
                    var selectValue = $(this).val();
                });

                // Once everything set, we have to remove clicked element and append that list with the next element
                elementToRemove.fadeOut(500, () => {
                    elementToRemove.hide(200, () => {
                        elementToRemove.remove();
                        NewElement.appendTo(EventsSection)
                            .hide()
                            .show(200, () => {
                                NewElement.fadeIn(500);
                            });
                    });
                });
                
            }
            
            // Or if there are no more elements to be added, we just have to delete clicked element
            else {
                elementToRemove.fadeOut(500, ()=> { elementToRemove.hide(200, () => { elementToRemove.remove(); });});
            }

            // and here we have to subtract this from the counter
            if (EventSectionClass === "not_known_events") {
                var $counter = $('.not_known_counter');
            }
            else if (EventSectionClass === "not_declared_events"){
                var $counter = $('.not_declared_counter')
            }

            var currentValue = parseInt($counter.text(), 10);
            if (!isNaN(currentValue)) {
                var newValue = currentValue - 1;
                $counter.text(newValue);
            } else {
                console.error("value cannot be parsed into integer");
            }

            // Here we chceck whether the whole section is going to be removed
            setTimeout(()=>{
                if ($('.not_known_events').html().trim() === "" && $('.not_declared_events').html().trim() === "") {
                    var wholeSection = $('.not_declared_events_div');
                    wholeSection.fadeOut(500, () => { wholeSection.remove(); });
                    $('.nav-declarations').removeClass('fw-bold text-primary').addClass('text-muted');
                }
                }, 800);

            // If we declared that we will be present or not, we have to move this event to the ongoing events list
            if (!AddToNotSure) {

                var $ongoingEventsCard = $('.ongoing-events');
                
                if (selectValue == 1 || selectValue == 0.5 || selectValue == 0.75){
                    setActiveOngoingEventTab($ongoingEventsCard, true);

                    if ($ongoingEventsCard.find('.body-ongoing-events').children().length == 0) {
                        $ongoingEventsCard.find('.body-ongoing-events').append(newOngoingEvent);
                    
                    } else {
                        moment.locale('pl');
                        var dateToCompareText = newOngoingEvent.find('.event-date').text();
                        var dateToCompare = moment(dateToCompareText, "DD MMMM YYYY");

                        var $ongoingEventItems = $ongoingEventsCard.find('.ongoing-event-item');
                        putElementToList($ongoingEventItems, dateToCompare, newOngoingEvent, '.ongoing-event-item');
                        setActiveOngoingEventTab($ongoingEventsCard, true);
                    }

                    addToCounter("attending_counter");
                
                } else if (selectValue == 0){
                    setActiveOngoingEventTab($ongoingEventsCard, false);
                    
                    if ($ongoingEventsCard.find('.body-ongoing-absent-events').children().length == 0){
                        $ongoingEventsCard.find('.body-ongoing-absent-events').append(newOngoingEvent);
                    
                    } else {
                        moment.locale('pl');
                        var dateToCompareText = newOngoingEvent.find('.event-date').text();
                        var dateToCompare = moment(dateToCompareText, "DD MMMM YYYY");

                        var $ongoingEventItems = $ongoingEventsCard.find('.ongoing-absent-event-item');
                        putElementToList($ongoingEventItems, dateToCompare, newOngoingEvent, '.ongoing-absent-event-item');
                        setActiveOngoingEventTab($ongoingEventsCard, false);

                    }
                    addToCounter("not_attending_counter");
                }

                // If there is no visible section with list of ongoing events (section is empty)
                if ($ongoingEventsCard.hasClass('d-none')) {
                    $ongoingEventsCard.removeClass('d-none').hide().show(200, ()=>{$ongoingEventsCard.fadeIn(500)});
                    $('.nav-ongoing-events').removeClass('text-muted').addClass('fw-bold text-primary');                    
                }

            } else if (AddToNotSure) {
                moment.locale('pl');

                var ClickedEventDate = NewNotSure.find('.event-date');
                var ClickedDate = ClickedEventDate.text();
                var ClickedDateMoment = moment(ClickedDate, "DD MMMM YYYY");

                var $NotKnownEventsCard = $('.not_known_events');
                var $elements = $NotKnownEventsCard.find('.ajax_section_element_event');
                if ($elements.length === 0) {
                    $NotKnownEventsCard.append(NewNotSure);
                } else {
                    putElementToList($elements, ClickedDateMoment, NewNotSure, '.not_known_event_element');
                }
                
                addToCounter("not_known_counter");

            }
        });
    });


// Function to show save button once something is chosen
$(document).ready(function() {
    $('.not_declared_songs').on('change', '.song_voice_declare', function() {
        var $select = $(this);
        var saveButtonClass = $select.data('save-button');
        var $saveButton = $('.' + saveButtonClass);
        $select.select2();

        if ($select.val() && $select.val().length > 0) {
            $saveButton.removeClass('d-none');
        } else {
            $saveButton.addClass('d-none');
        }
    });
});


$(document).ready(function() {
    $('.not_declared_songs').on('click', '.save-song-button', function() {
        var $saveButton = $(this);
        var elementToRemove = $(this).closest('.ajax_section_element_song');
        var ensembleSlug = $saveButton.data('ensemble-slug');
        var songSlug = $saveButton.data('song-slug');
        var $selectField = $(".select-song-" + songSlug);

        var selectedOptions = $selectField.val();
        var url = `/api/song/${ensembleSlug}/${songSlug}/set_voices`;
        var elementsToDeclare = $('.not_declared_songs');

        sendAJAX(url, selectedOptions, (responseData)=>{

            if (Object.keys(responseData).length !== 0) {
                var NewElement = elementToRemove.clone();
                elementToRemove.fadeOut(500, ()=> { elementToRemove.hide(200, () => { elementToRemove.remove(); });});

                NewElement.find('.song_composer').text(responseData.composer);
                NewElement.find('a').text(responseData.song_name);
                var newURLSong = '/song/' + responseData.ensembleSlug + '/' + responseData.song_slug + '/0'
                NewElement.find('a').attr("href", newURLSong);
                var $newSelect = NewElement.find('select');
                NewElement.find('.select2-container').remove();
                $newSelect.empty();
                $newSelect.attr('class', 'select2 form-control-sm song_voice_declare select-song-' + responseData.song_slug)
                $newSelect.attr('data-save-button', 'save-button-' + responseData.song_slug);
                $.each(responseData.voices, function(index, value){
                    $newSelect.append($('<option>', {
                        value: value.slug,
                        text: value.name
                    }));
                });
                $newSelect.trigger('change');
                $newSelect.select2();

                NewElement.find('.save-button').attr('class', 'pb-3 pt-1 d-none save-button save-button-' + responseData.song_slug)
                NewElement.find('button').attr('data-song-slug', responseData.song_slug);
                NewElement.find('button').attr('data-ensemble-slug', responseData.ensembleSlug);

                NewElement.appendTo(elementsToDeclare)
                    .hide()
                    .fadeIn(300);
            }

            else {

                elementToRemove.fadeOut(500, ()=> { elementToRemove.hide(200, () => { elementToRemove.remove(); });});
            }
            setTimeout(()=>{
            if (elementsToDeclare.html().trim() === "") {
                var songsSection = $('.not_declared_songs_div');
                songsSection.fadeOut(500, () => { songsSection.remove(); });
                $('.nav-voices').removeClass('fw-bold text-primary').addClass('text-muted');
            }
            }, 800);
        });
    });
});


document.querySelectorAll('.navbar-item').forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement && (!targetElement.closest('div') || !targetElement.closest('div').classList.contains('d-none'))){
        const offset = 100;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - offset;
    
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });